import type { Carer, ConsentForm } from '@lmc/ts-common'
import { ComplexCard } from '@lmc/ui-kit'
import dayjs from 'dayjs'
import type * as React from 'react'
import type { CSSProperties } from 'react'

type LastReviewCardProps = {
  consentForm: ConsentForm
  lastReviewCarer: Carer
  style: CSSProperties
  translate: (id: string, variable?: any) => string
}

export const LastReviewCard = ({
  consentForm,
  lastReviewCarer,
  style,
  translate
}: LastReviewCardProps): React.ReactElement => {
  const lastReviewDateLabel = consentForm?.editedOn
    ? dayjs(consentForm?.editedOn).format('DD-MM-YYYY • HH:mm')
    : translate('noReviewsYet')
  return (
    <ComplexCard
      localisation={{
        title: translate('lastReview'),
        review: ''
      }}
      dateValue={lastReviewDateLabel}
      style={style as CSSProperties}
      rightChildren=""
      // @ts-ignore
      user={
        lastReviewCarer
          ? {
              name: `${lastReviewCarer?.name?.first}${' '}${
                lastReviewCarer?.name.last
              }`,
              picture: lastReviewCarer?.picture
            }
          : undefined
      }
    />
  )
}

export default LastReviewCard
